module.exports = {
  API: "https://crm.flirtdart.com/api/v1",
  API_EMAIL_SENDER: "https://crm.flirtdart.com/api/v1",
  APIROOT: "wss://crm.flirtdart.com",
  WEB: "https://flirtdart.com",
  DASHBOARD: "https://admin.flirtdart.com",
  PRODUCTION: true,
  drawerWidth: 240,
};
